import React, { ReactNode, useEffect } from 'react';
import * as S from './Popup.styles';
import { useTranslation } from 'react-i18next';

interface Props {
    title?: string;
    save(): void;
    close(): void;
	children: ReactNode;
}

export default function Popup(props: Props): JSX.Element {

    const popupOpenEvent = React.useMemo(() => new CustomEvent('onCentralAuthPopupOpened'), []);
    const popupCloseEvent = React.useMemo(() => new CustomEvent('onCentralAuthPopupClosed'), []);
    const { t } = useTranslation();

    const save = (e: React.SyntheticEvent) => {
        props.save();
        e.preventDefault();
    };

    const close = () => {
        window.dispatchEvent(popupCloseEvent);
        props.close();
    };

    useEffect(() => {
        window.dispatchEvent(popupOpenEvent);
    }, [popupOpenEvent]);

    return (
        <S.PopupWrapper>
            <S.PopupHeader>
                <S.CloseButton onClick={close}>
                    <S.CloseIcon size={32} />
                    <S.CloseText>{t('BUTTON.LABEL_EXIT')}</S.CloseText>
                </S.CloseButton>
            </S.PopupHeader>
            <S.PopupBody>
                <S.HeaderTitle>{props.title}</S.HeaderTitle>
                <S.Card>
                    {props.children}
                </S.Card>
            </S.PopupBody>
            <S.PopupFooter>
                <S.ActionSection>
                    <S.ButtonSection>
                        <S.ActionButton onClick={close}>{t('BUTTON.LABEL_CANCEL')}</S.ActionButton>
                        <S.ActionButton onClick={save}>{t('BUTTON.LABEL_SAVE')}</S.ActionButton>
                    </S.ButtonSection>
                </S.ActionSection>
            </S.PopupFooter>
        </S.PopupWrapper>
    );
}
